import { render, staticRenderFns } from "./TelFindPwd.vue?vue&type=template&id=0f42148f&scoped=true"
import script from "./TelFindPwd.vue?vue&type=script&lang=js"
export * from "./TelFindPwd.vue?vue&type=script&lang=js"
import style0 from "./TelFindPwd.vue?vue&type=style&index=0&id=0f42148f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f42148f",
  null
  
)

export default component.exports